import React from 'react';
import { toast } from 'react-toastify';
import { Icon } from '../../subkit-ui';
import { copyTextToClipboard } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LinkCopyBox = function LinkCopyBox(_ref) {
  var link = _ref.link;
  return /*#__PURE__*/_jsxs("div", {
    className: "border border-gray-300 p-3 rounded relative h-12 cursor-pointer",
    onClick: function onClick() {
      copyTextToClipboard(link);
      toast.info('Link copied to clipboard');
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "absolute left-3 right-9 truncate text-subkit-primary fw-500",
      children: link
    }), /*#__PURE__*/_jsx("div", {
      className: "absolute right-0 items-center inset-y-0",
      children: /*#__PURE__*/_jsx(Icon, {
        name: "link",
        type: "regular",
        className: "m-4 text-neutral-500 fw-800"
      })
    })]
  });
};

export default LinkCopyBox;